import { defineComponent as _defineComponent } from 'vue'
import {
  AccountStates,
  EAccountStatusAction
} from '@/modules/common/services/http/account';
import { getCustomTheme } from '@/modules/common/services/local-storage';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { BaseText, ButtonPrimary, Heading } from '@warrenbrasil/nebraska-web';
import { computed, onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeAccountStatus',
  props: {
  accountStatusResponse: {
    type: Object as () => AccountStates,
    required: true
  }
},
  setup(__props) {

const props = __props


const storeHref = ref('');
const button = props.accountStatusResponse.accountStatus.button;

function mountStoreHref() {
  const currentUrl = window.location.href;
  const baseUrl = currentUrl.split('/#/')[0];
  storeHref.value = `${baseUrl}/#/mobile`;
}

const isMobile = ref(false);

function checkIfMobile() {
  isMobile.value = window.innerWidth <= 768;
}

onMounted(() => {
  checkIfMobile();
});

const routeMapping: Record<
  EAccountStatusAction,
  { mobile: string; desktop: string }
> = {
  [EAccountStatusAction.FacematchRejected]: {
    mobile: 'states/face-match',
    desktop: 'states/face-match'
  },
  [EAccountStatusAction.FacematchRequired]: {
    mobile: 'states/face-match',
    desktop: 'states/face-match'
  },
  [EAccountStatusAction.RegisterAddressReview]: {
    mobile: 'states/register-address-review',
    desktop: 'states/register-address-review'
  },
  [EAccountStatusAction.RegisterDocuments]: {
    mobile: 'register-documents/document',
    desktop: 'documents-info'
  },
  [EAccountStatusAction.RegisterFinancialLife]: {
    mobile: 'financial-life/profession',
    desktop: 'financial-life'
  },
  [EAccountStatusAction.RegisterPersonal]: {
    mobile: 'personal-info/nationality',
    desktop: 'personal-info'
  }
};

const buttonHref = computed(() => {
  const theme = getCustomTheme();

  const domain = theme?.brandDomain
    ? theme.brandDomain.toLowerCase()
    : 'warren';
  const platform = isMobile.value ? 'mobile' : 'desktop';

  if (button?.action) {
    const route = routeMapping[button?.action][platform];
    return `/onboarding/${domain}/${platform}/${route}`;
  }

  return '';
});

onMounted(() => {
  mountStoreHref();
});

return { __sfc: true,props, storeHref, button, mountStoreHref, isMobile, checkIfMobile, routeMapping, buttonHref, NebraskaColors, BaseText, ButtonPrimary, Heading }
}

})